// Small imperative motion helpers shared by the auth flow.

export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Short horizontal shake — the "no" gesture for a rejected field. */
export function shake(el: Element | null | undefined) {
  if (!el || prefersReducedMotion()) return;
  el.animate(
    [0, -6, 5, -3, 2, 0].map((x) => ({ transform: `translateX(${x}px)` })),
    { duration: 320, easing: "ease-out" },
  );
}
